<script setup lang="ts">
import WidgetRecordAction from '@/components/widget/WidgetRecordAction.vue'

defineProps<{
  items: Array<any>,
  readonly: boolean
}>()

defineEmits(['removeItem'])
</script>

<template>
  <div v-if="items?.length">
    <VTable>
      <thead>
        <tr>
          <th>ФИО</th>
          <th>Должность</th>
          <th>Основание</th>
          <th
            v-if="!readonly"
            class="mw-100 text-center"
          >
            Действие
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in items"
          :key="item.Bundle?.Uuid"
        >
          <!-- ФИО -->
          <td>
            {{ item.Fio || '—' }}
          </td>

          <!-- Должность -->
          <td>
            {{ item.Position || '—' }}
          </td>

          <!-- Основание -->
          <td>
            {{ item.Basis || '—' }}
          </td>

          <!--  -->
          <td
            v-if="!readonly"
            class="text-center"
          >
            <WidgetRecordAction
              :selected="true"
              view
              @delete="$emit('removeItem', item)"
            />
          </td>
        </tr>
      </tbody>
    </VTable>
  </div>
</template>
